import React, { Component } from "react";
// reactstrap components
import { FormGroup, Input, Label } from "reactstrap";

export default class StringInput extends Component {
  displayError() {
    const error = this.props.error;
    if (typeof error != "undefined" && error != null) {
      return <div className='text-danger'>{error.text}</div>;
    }
  }

  render() {
    return (
      <FormGroup className='mt-3'>
        <Label htmlFor={this.props.name} className='font-weight-bold'>
        {this.props.qIndex}. {this.props.label}
        </Label>
        <Input
          type={"text"}
          className='form-control mb-2'
          id={this.props.name}
          name={this.props.name}
          placeholder={"Please fill in"}
          value={this.props.currentValue != null ? this.props.currentValue : ""}
          onChange={(e) => {
            // this.setState({[question.key]: e.target.value})
            this.props.handleChange(this.props.name, e.target.value);
          }}
        />
        {this.displayError()}
      </FormGroup>
    );
  }
}
